import { Box, CenteredBox } from '.'
import './Timeline.scss'

export const Timeline = ({ frames, selectedNode, onNodeSelected, playDuration, ...props }) => {
  const playing = !!playDuration

  return (
    <Box
      container
      alignItems="center"
      px={32}
      {...props}
    >
      <Box
        position="absolute"
        left={32}
        right={32}
        style={{ borderBottom: '1px solid white' }}
      />
      {frames.map((duration, i) =>
        <Box key={i} container width={`${duration * 100}%`}>
          <CenteredBox
            position="absolute"
            left={-32}
            top={-32}
            className="node-button"
            width={65}
            height={65}
            radius="50%"
            onClick={() => onNodeSelected(i)}
            cursor="pointer"
            zIndex={1}
          >
            <Box
              width={17}
              height={17}
              r="50%"
              border="1px solid white"
              background={i === selectedNode ? 'white' : 'black'}
            />
          </CenteredBox>
        </Box>
      )}
      <Box position="absolute" left={24} right={40} alignItems="center">
        <Box
          position="absolute"
          width={17}
          height={17}
          r="50%"
          background={playing ? 'var(--yellow)' : 'transparent'}
          left={playing ? '100%' : '0%'}
          transition={playing && `left ${playDuration}ms linear`}
        />
      </Box>
    </Box>
  )
}